import React, { useState } from "react";
import { Box, IconButton, InputLabel, TextField } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import PaperWithThreeStripsIcon from "../../../../shared/assets/icons/PaperWithThreeStripsIcon";
import OverflowTooltip from "../../../../shared/components/OverflowTooltip";
import colors from "../../../../shared/themes/colors";
import { formatFileSize } from "../../../../shared/models/models";
import { ChangeDocument, DocumentFile } from "../../models/machineDocumentsModel";
import { FieldErrors, UseFormClearErrors, UseFormRegister, UseFormSetValue } from "react-hook-form";
import useTranslation from "../../../../shared/hooks/useTranslation";

interface DocumentFileProps {
  document: DocumentFile | null;
  documentIndex: number;
  register: UseFormRegister<{
    documents: ChangeDocument[];
  }>;
  setValue: UseFormSetValue<{
    documents: ChangeDocument[];
  }>;
  errors: FieldErrors<{
    documents: ChangeDocument[];
  }>;
  clearErrors?: UseFormClearErrors<{
    documents: ChangeDocument[];
  }>;
  isCreate: boolean;
  onDelete?: () => void;
}

const DocumentFileItem = ({
  document,
  register,
  errors,
  clearErrors,
  isCreate,
  onDelete,
  documentIndex,
  setValue
}: DocumentFileProps) => {
  const { translate } = useTranslation("myMachinery");
  const { translate: tCommon } = useTranslation("common");
  return (
    <Box>
      {document && (
        <Box className="w-full py-3 px-4" sx={{ background: colors.secondary.gray96, borderRadius: "4px" }}>
          <Box className="flex justify-between items-center gap-2 w-full">
            <Box className="flex items-center gap-2">
              <PaperWithThreeStripsIcon />
              <Box sx={{ width: "110px" }}>
                <OverflowTooltip text={document.name} className="text-16-medium" color={"#333333"} />
              </Box>
            </Box>

            <Box className="flex gap-2 items-center">
              <Box className="text-16-medium" color="#7A8093">
                {formatFileSize(document.size)}
              </Box>

              {isCreate && (
                <IconButton onClick={() => onDelete?.()}>
                  <CloseIcon sx={{ color: colors.primary.red, fontSize: "16px" }} />
                </IconButton>
              )}
            </Box>
          </Box>

          <Box className="mt-2">
            <InputLabel>{translate("amendFileName")}</InputLabel>
            <TextField
              className="w-full"
              sx={{
                background: "#fff",
                ".MuiFormHelperText-root.Mui-error": {
                  background: colors.secondary.gray96,
                  margin: 0,
                  paddingTop: "4px"
                }
              }}
              {...register(`documents.${documentIndex}.name`, {
                required: tCommon("forms.required"),
                maxLength: { value: 50, message: translate("titleTooLong") }
              })}

              onChange={(event) => {
                clearErrors?.(`documents.${documentIndex}.name`);
                setValue(`documents.${documentIndex}.name`, event.target.value, { shouldValidate: true });
              }}
              error={!!errors?.documents?.[documentIndex]?.name}
              helperText={errors?.documents?.[documentIndex]?.name?.message || ""}
            />
          </Box>
        </Box>
      )}
    </Box>
  );
};
export default DocumentFileItem;